import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { CustomerFormService } from 'src/app/services/customer-form.service';
import { ProductsService } from 'src/app/services/products.service';
import Swal from 'sweetalert2';

export enum DialogPosition {
  Center = 'center',
  Right = 'right',
  Left = 'left',
  Top = 'top',
  Bottom = 'bottom',
  TopLeft = 'topleft',
  TopRight = 'topright',
  BottomLeft = 'bottomleft',
  BottomRight = 'bottomright'
}

@Component({
  selector: 'app-custom-component',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './custom-component.component.html',
  styleUrl: './custom-component.component.scss'
})
export class CustomComponentComponent {
  @Input('customForm') inputCustomForm?: FormGroup | any;
  @Input('instanceId') instanceId: number;
  customForm: FormGroup
  numberInputWithLabels: FormArray;
  dropdownWithLabel: FormArray;
  checkboxWithLabel: FormArray;
  option: FormArray;
  radioButtons: FormArray;
  radioOption: FormArray;
  multiCheckInput: FormArray;
  multiCheckOption: FormArray;
  isdisplay: boolean = false
  isImage: boolean = false
  isFormView: boolean = false;
  selectedFormView;//it's not used
  galleryImages: { name: string, path: string }[] = []
  numberCurrentInd = 0
  dropdownCurrentInd = 0
  checkboxCurrentInd = 0
  radioCurrentInd = 0
  multiCheckCurrentInd = 0
  selectedImage;
  isMakeQuestion: boolean = false
  isSelected: boolean = false
  questionList: any = []
  selectedControl = []
  visible: boolean = false;
  position: DialogPosition = DialogPosition.Bottom;
  uploadControl;
  controls = [
    { name: 'Number', value: 'number', selected: false },
    { name: 'Dropdown', value: 'dropdown', selected: false },
    { name: 'Checkbox', value: 'checkbox', selected: false },
    { name: 'Radio', value: 'radio', selected: false },
    { name: 'Image', value: 'image', selected: false },
  ];
  imageSizes = [
    { label: 'Small', value: 'small' },
    { label: 'Medium', value: 'medium' },
    { label: 'Large', value: 'large' }
  ];
  imagePositions = [
    { label: 'Top', value: 'top' },
    { label: 'Right', value: 'right' },
    { label: 'Left', value: 'left' },
    { label: 'Bottom', value: 'bottom' }
  ];

  selectedImageUrl: string = 'assets/images/no-image.png';
  constructor(private fb: FormBuilder, private customerFormService: CustomerFormService, private messageService: MessageService, private cd: ChangeDetectorRef, private productService: ProductsService) {
    this.galleryImages = this.customerFormService.galleryImages;
  }

  ngOnInit(): void {
    this.getAllCustomForm();
    if (!this.inputCustomForm) {
      this.customForm = this.createCustomForm();
      this.initializeDefaultValues();
    }
  }

  createCustomForm() {
    return this.fb.group({
      title: ['', Validators.required],
      image: [''],
      imageSize: ['medium'],
      imagePosition: ['top'],
      numberInputWithLabels: new FormArray([]),
      dropdownWithLabel: new FormArray([]),
      checkboxWithLabel: new FormArray([]),
      radioButtons: new FormArray([]),
    });
  }

  ngOnChanges() {
    if (this.inputCustomForm && this.inputCustomForm !== '' && this.inputCustomForm !== null) {
      // inputCustomForm puede ser un FormGroup o un objeto plano
      let itemValue;

      if (typeof this.inputCustomForm.getRawValue === 'function') {
        // Es un FormGroup
        itemValue = this.inputCustomForm.getRawValue();
      } else if (typeof this.inputCustomForm.value !== 'undefined') {
        // Podría ser un FormGroup con property value
        itemValue = this.inputCustomForm.value;
      } else {
        // Es un objeto plano
        itemValue = this.inputCustomForm;
      }
      this.editValue(itemValue);
    } else {
      // Si no hay datos, inicializar con valores por defecto
      this.initializeDefaultValues();
    }
  }

  initializeDefaultValues() {
    this.isMakeQuestion = false;
    this.controls = [
      { name: 'Number', value: 'number', selected: false },
      { name: 'Dropdown', value: 'dropdown', selected: false },
      { name: 'Checkbox', value: 'checkbox', selected: false },
      { name: 'Radio', value: 'radio', selected: false },
      { name: 'Image', value: 'image', selected: false },
    ];
    this.selectedControl = [];
    this.isImage = false;
    this.cd.detectChanges();
  }

  showDialog(position: string, control) {
    this.position = position as DialogPosition;
    this.visible = true;
    this.uploadControl = control;
  }

  toggleImage(image) {
    this.selectedImage = this.selectedImage === image ? null : image;
  }

  uploadImage() {
    this.customForm.controls['image'].setValue(this.selectedImage.path);
    this.visible = false;
    this.selectedImage = undefined;
  }

  addnumberInputWithLabels(): void {
    this.numberInputWithLabels = this.customForm.get('numberInputWithLabels') as FormArray;
    this.numberInputWithLabels.push(this.createnumberInputWithLabels(''));
    this.numberCurrentInd = this.numberCurrentInd + 1
  }

  removenumberInputWithLabels(i): void {
    this.numberInputWithLabels = this.customForm.get('numberInputWithLabels') as FormArray;
    this.numberInputWithLabels.removeAt(i);
    this.numberCurrentInd = this.numberCurrentInd - 1
  }

  adddropdownWithLabel(): void {
    this.dropdownWithLabel = this.customForm.get('dropdownWithLabel') as FormArray;
    this.dropdownWithLabel.push(this.createdropdownWithLabel(''));
    this.dropdownCurrentInd = this.dropdownCurrentInd + 1
  }

  removedropdownWithLabel(i): void {
    this.dropdownWithLabel = this.customForm.get('dropdownWithLabel') as FormArray;
    this.dropdownWithLabel.removeAt(i);
    this.dropdownCurrentInd = this.dropdownCurrentInd - 1
  }

  addcheckboxWithLabel(): void {
    this.checkboxWithLabel = this.customForm.get('checkboxWithLabel') as FormArray;
    this.checkboxWithLabel.push(this.createcheckboxWithLabel(''));
    this.checkboxCurrentInd = this.checkboxCurrentInd + 1

  }

  removecheckboxWithLabel(i): void {
    this.checkboxWithLabel = this.customForm.get('checkboxWithLabel') as FormArray;
    this.checkboxWithLabel.removeAt(i);
    this.checkboxCurrentInd = this.checkboxCurrentInd - 1
  }

  optionControls(id: number) {
    return this.checkboxWithLabelControls.at(id).get("option") as FormArray;
  }

  addradioButtons(index: number): void {
    this.radioButtons = this.customForm.get('radioButtons') as FormArray;
    this.radioButtons.push(this.createradioButtons(''));
    this.radioCurrentInd = this.radioCurrentInd + 1
  }

  removeradioButtons(i): void {
    this.radioButtons = this.customForm.get('radioButtons') as FormArray;
    this.radioButtons.removeAt(i);
    this.radioCurrentInd = this.radioCurrentInd - 1
  }

  radioOptionControls(id: number) {
    return this.radioButtonsControls.at(id).get("option") as FormArray;
  }

  get numberInputWithLabelsControls() {
    return this.customForm.get("numberInputWithLabels") as FormArray;
  }
  get dropdownWithLabelControls() {
    return this.customForm.get("dropdownWithLabel") as FormArray;
  }
  get checkboxWithLabelControls() {
    return this.customForm.get("checkboxWithLabel") as FormArray;
  }
  get radioButtonsControls() {
    return this.customForm.get("radioButtons") as FormArray;
  }

  createnumberInputWithLabels(ele): FormGroup {
    return this.fb.group({
      leftLabel: [ele.leftLabel ? ele.leftLabel : '', [Validators.required]],
      rightLabel: [ele.rightLabel ? ele.rightLabel : '', [Validators.required]],
      inputNumberValue: [ele.inputNumberValue ? ele.inputNumberValue : '']
    });
  }

  createdropdownWithLabel(ele): FormGroup {
    return this.fb.group({
      label: [ele.label ? ele.label : '', [Validators.required]],
      type: [ele.type ? ele.type : 'dropdown', Validators.required],
      options: [ele.options ? ele.options : '', [Validators.required]]
    });
  }

  createcheckboxWithLabel(ele): FormGroup {
    return this.fb.group({
      label: [ele.label ? ele.label : '', [Validators.required]],
      type: [ele.type ? ele.type : 'checkbox', Validators.required],
      default: [ele.default ? ele.default : ''],
      options: [ele.options ? ele.options : '', [Validators.required]]
    });
  }

  createradioButtons(ele): FormGroup {
    return this.fb.group({
      type: [ele.type ? ele.type : 'radioButtons', Validators.required],
      options: [ele.options ? ele.options : []]
    });
  }

  createFileInput(): FormGroup {
    return this.fb.group({
      image: ['', Validators.required],
      title: [''],
      isSelected: false,
      button: this.fb.array([])
    });
  }

  submit() {
    return this.customForm;
  }

  formClear() {
    this.customForm.reset()
    const numberInputWithLabels = this.customForm.get('numberInputWithLabels') as FormArray;
    numberInputWithLabels.controls = []
    const dropdownWithLabel = this.customForm.get('dropdownWithLabel') as FormArray;
    dropdownWithLabel.controls = []
    const checkboxWithLabel = this.customForm.get("checkboxWithLabel") as FormArray;
    checkboxWithLabel.controls = []
    const radioButtons = this.customForm.get("radioButtons") as FormArray;
    radioButtons.controls = []
    const multiCheckInput = this.customForm.get("multiCheckInput") as FormArray;
    multiCheckInput.controls = []
  }

  addCustomForm() {
    this.isMakeQuestion = !this.isMakeQuestion
    this.formClear()
  }

  typeChange(event) {
    // event.value contiene el array completo de valores seleccionados
    const selectedValues = event.value || [];

    // Actualizar el estado de selected en cada control
    this.controls.forEach((control) => {
      control.selected = selectedValues.includes(control.value);
    });

    // Determinar qué valor cambió (agregado o removido)
    const changedValue = event.itemValue?.value || event.itemValue;
    const isSelected = selectedValues.includes(changedValue);

    const value = changedValue;

    if (value === 'number' && this.customForm.controls['numberInputWithLabels']['length'] === 0 && isSelected) {
      this.addnumberInputWithLabels();
    } else if (value === 'number' && !isSelected) {
      const numberInputWithLabels = this.customForm.get('numberInputWithLabels') as FormArray;
      numberInputWithLabels.controls = []
    }
    else if (value === 'dropdown' && this.customForm.controls['dropdownWithLabel']['length'] === 0 && isSelected) {
      this.adddropdownWithLabel();
    } else if (value === 'dropdown' && !isSelected) {
      const dropdownWithLabel = this.customForm.get('dropdownWithLabel') as FormArray;
      dropdownWithLabel.controls = []
    }
    else if (value === 'checkbox' && this.customForm.controls['checkboxWithLabel']['length'] === 0 && isSelected) {
      this.addcheckboxWithLabel();
    } else if (value === 'checkbox' && !isSelected) {
      const checkboxWithLabel = this.customForm.get("checkboxWithLabel") as FormArray;
      checkboxWithLabel.controls = []
    }
    else if (value === 'radio' && this.customForm.controls['radioButtons']['length'] === 0 && isSelected) {
      this.addradioButtons(0);
    }
    else if (value === 'radio' && !isSelected) {
      const radioButtons = this.customForm.get("radioButtons") as FormArray;
      radioButtons.controls = []
    }
    else if (value === 'image' && isSelected) {
      this.isImage = true
    }
    else if (value === 'image' && !isSelected) {
      this.isImage = false
      this.customForm.controls['image'].setValue('');
    }

  }

  selectImage(event: any) {
    const file = event.target.files[0];

    if (file) {
      const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!allowedFileTypes.includes(file.type)) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid file type. Please select a valid image file.' });
        event.target.value = '';
      }

      else {
        const reader = new FileReader();
        reader.onload = () => {
          const name = file.name;
          const base64 = reader.result.toString();
          const blob = base64.split(",")[1];
          Swal.showLoading()
          this.productService.uploadFile(name, blob).subscribe(
            (res: any) => {
              this.customForm.controls['image'].setValue(res.fileUrl);
              Swal.close()
              // Set the selectedImageUrl for the specific item
              // item.selectedImageUrl = res.fileUrl;
            },
            (error) => {
            }
          );
        };
        if (file) {
          reader.readAsDataURL(file);
        }
      }
    }
  }

  showTableView() {
    this.isFormView = false;
  }

  editValue(item) {

    this.isMakeQuestion = true
    this.customForm = this.createCustomForm();

    // Verificar que item tenga las propiedades esperadas
    if (!item) {
      return;
    }

    // Asegurar que las propiedades existan como arrays
    // Soportar ambos formatos: directamente en item o dentro de choices
    const numberInputWithLabels = item.numberInputWithLabels || item.choices?.numberInputWithLabels || [];
    const dropdownWithLabel = item.dropdownWithLabel || item.choices?.dropdownWithLabel || [];
    const checkboxWithLabel = item.checkboxWithLabel || item.choices?.checkboxWithLabel || [];
    const radioButtons = item.radioButtons || item.choices?.radioButtons || [];
    const image = item.image || '';
    const imageSize = item.imageSize ? item.imageSize : 'medium';
    const imagePosition = item.imagePosition ? item.imagePosition : 'top';

    // Reinicializar los controles con el estado correcto
    this.controls = [
      { name: 'Number', value: 'number', selected: numberInputWithLabels.length > 0 },
      { name: 'Dropdown', value: 'dropdown', selected: dropdownWithLabel.length > 0 },
      { name: 'Checkbox', value: 'checkbox', selected: checkboxWithLabel.length > 0 },
      { name: 'Radio', value: 'radio', selected: radioButtons.length > 0 },
      { name: 'Image', value: 'image', selected: image !== '' && image !== null }
    ];

    // Crear selectedControl como array de valores seleccionados
    this.selectedControl = this.controls
      .filter(control => control.selected)
      .map(control => control.value);

    // Configurar el estado de la imagen
    this.isImage = image !== '' && image !== null;

    // Resetear los índices
    this.numberCurrentInd = 0;
    this.dropdownCurrentInd = 0;
    this.checkboxCurrentInd = 0;
    this.radioCurrentInd = 0;

    this.customForm.patchValue({
      title: item.title || '',
      image: image,
      imageSize: imageSize,
      imagePosition: imagePosition
    });
    this.cd.detectChanges();

    numberInputWithLabels.forEach((ele) => {
      this.numberInputWithLabels = this.customForm.get('numberInputWithLabels') as FormArray;
      this.numberInputWithLabels.push(this.createnumberInputWithLabels(ele));
      this.numberCurrentInd = this.numberCurrentInd + 1
    })

    dropdownWithLabel.forEach((ele) => {
      this.dropdownWithLabel = this.customForm.get('dropdownWithLabel') as FormArray;
      this.dropdownWithLabel.push(this.createdropdownWithLabel(ele));
      this.dropdownCurrentInd = this.dropdownCurrentInd + 1
    })

    checkboxWithLabel.forEach((ele, index) => {
      this.checkboxWithLabel = this.customForm.get('checkboxWithLabel') as FormArray;
      this.checkboxWithLabel.push(this.createcheckboxWithLabel(ele));
      this.checkboxCurrentInd = this.checkboxCurrentInd + 1
    })

    radioButtons.forEach((ele, index) => {
      this.radioButtons = this.customForm.get('radioButtons') as FormArray;
      this.radioButtons.push(this.createradioButtons(ele));
      this.radioCurrentInd = this.radioCurrentInd + 1
    })
    this.cd.detectChanges();
  }

  getAllCustomForm() {
    this.customerFormService.getCustomForm().subscribe((res) => {
      this.questionList = res
    })
  }
}
